import { RouteObject } from "react-router-dom";
import { AdminFunctionsPage } from "./adminFunctionsPage/AdminFunctionsPage";
import { hasAdminRole } from "../../utils/authenticationUtils";

const url = "adminfunctions";

// Use in same file
// eslint-disable-next-line
export const adminFunctionsRoutes = {
    main: `/${url}`
}

export const AdminFunctionsNavigation = (): RouteObject[] => {
    // Admin Functions only for admins
    return hasAdminRole() ?
        [
            {
                path: adminFunctionsRoutes.main,
                element: <AdminFunctionsPage />
            }
        ] :
        []
}
